export interface PendingChangesBarProps {
  count: number;
  saving?: boolean;
  error?: string | null;
  onViewChanges: () => void;
  onDiscard: () => void;
  onSave: () => void;
}

const CLS_FOOT_BTN = [
  "inline-flex items-center justify-center",
  "h-8 px-3.5 rounded-(--radius-field)",
  "text-sm font-medium cursor-pointer",
  "transition-[background,color,border-color] duration-120",
  "disabled:cursor-default disabled:opacity-60",
].join(" ");

/**
 * Horizontal save bar for the ROI draft. Rendered by the caller only when
 * the draft is dirty. Shows the pending-change count (and an optional save
 * error), plus View changes / Discard / Save actions.
 */
export function PendingChangesBar({
  count,
  saving,
  error,
  onViewChanges,
  onDiscard,
  onSave,
}: PendingChangesBarProps) {
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2.5 rounded-(--radius-container) border border-(--border-subtle) bg-(--bg-white)">
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-sm text-(--fg-secondary)">
          {count} pending change{count === 1 ? "" : "s"}
        </span>
        {error && (
          <span className="text-[12.5px] text-(--status-error-text,#b91c1c) truncate">
            {error}
          </span>
        )}
      </div>
      <div className="inline-flex items-center gap-2">
        <button
          type="button"
          className={`${CLS_FOOT_BTN} bg-transparent text-(--fg-secondary) hover:bg-(--bg-hover) hover:text-(--fg-primary)`}
          onClick={onViewChanges}
          disabled={saving}
        >
          View changes
        </button>
        <button
          type="button"
          className={`${CLS_FOOT_BTN} bg-transparent text-(--fg-secondary) hover:bg-(--bg-hover) hover:text-(--fg-primary)`}
          onClick={onDiscard}
          disabled={saving}
        >
          Discard
        </button>
        <button
          type="button"
          className={`${CLS_FOOT_BTN} bg-(--brand-navy) text-(--fg-inverse) hover:bg-(--steel-110)`}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
